import { render } from "./CoBrandFolio.vue?vue&type=template&id=6b35aca3&scoped=true"
import script from "./CoBrandFolio.vue?vue&type=script&lang=js"
export * from "./CoBrandFolio.vue?vue&type=script&lang=js"

import "./CoBrandFolio.vue?vue&type=style&index=0&id=6b35aca3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b35aca3"]])

export default __exports__